import { isOrder } from '@repo/types/order';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { checkAssetModificationOptions, preventCancelation } from '@/utils/asset.utils';

interface AssetActionButton {
    isButtonDisabled: boolean;
    reasonText: string;
    isModificationButtonDisabled: boolean;
    modificationReasonText: string;
}

export const useAssetActionButton = (): AssetActionButton => {
    const { assetType, assetId } = useAssetParams();
    const { data } = useAsset(assetType, assetId);

    if (!data) {
        return {
            isButtonDisabled: false,
            reasonText: '',
            isModificationButtonDisabled: false,
            modificationReasonText: '',
        };
    }

    let isButtonDisabled = false;
    let reasonText = '';
    let isModificationButtonDisabled = false;
    let modificationReasonText = '';

    if (isOrder(data)) {
        ({ isButtonDisabled, reasonText } = preventCancelation(data));
    }

    try {
        const assetModificationOptions = checkAssetModificationOptions(data, assetId);
        if (assetModificationOptions) {
            isModificationButtonDisabled = assetModificationOptions.isModificationButtonDisabled;
            modificationReasonText = assetModificationOptions.modificationReasonText;
        }
    } catch {
        isModificationButtonDisabled = false;
        modificationReasonText = '';
    }

    return { isButtonDisabled, reasonText, isModificationButtonDisabled, modificationReasonText };
};
